<template>
  <main class="collections">
    <div class="links">
      <router-link class="lundi" v-for="collection in collections" :key="collection.uid" :to="{ name: 'collection', params: { collection: $route.params.collection, id: collection.uid } }">{{ collection.title }}</router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: "Collections",
  created() {
    if (this.$store.state.collections.length === 0) {
      this.$store.dispatch("loadCollections", this.$route.params.collection);
    }
  },
  computed: {
    collections() {
      return this.$store.state[this.$route.params.collection];
    }
  }
};
</script>

<style lang="scss" scoped>
.links {
    a {
        padding: var(--lh);
      //   padding-bottom:2vw;
        border-bottom: 1px solid black;
        display:block;
        font-size: calc(8 * 1vw);
        line-height:1;
        text-align:center;
         letter-spacing: 0.3vw;
         text-transform:uppercase;
    }
}
</style>
